import { Phone } from './ui.interfaces';

export interface Companion {
  basicCompanionData?: BasicCompanionData;
  frequentFlyerLabelValue?: string;
  frequentFlyerNumberValue?: string;
  genderDOBEditable?: boolean;
  isCurrentCompanion?: boolean;
  isSFPDMatch?: boolean;
  isSFPDOnFile?: boolean;
  loyaltyProgram?: LoyaltyProgram;
  loyaltyProgramDescription?: string;
  loyaltyProgramEditable?: boolean;
  nameEditable?: boolean;
  phone?: Phone;
  sequenceNumber?: string;
}

export interface BasicCompanionData {
  birthDate?: BirthDateMasked;
  knownTravelerNumber?: string;
  name: NameMasked;
  redressNumber?: string;
  tlMaskInfo_gender?: string;
}

export interface LoyaltyProgram {
  isPrimary?: boolean;
  programCode?: string;
  programNumber?: string;
}

export interface BirthDateMasked {
  tlMaskInfo_day: number;
  tlMaskInfo_hour?: number;
  tlMaskInfo_minute?: number;
  tlMaskInfo_month: number;
  tlMaskInfo_second?: number;
  tlMaskInfo_year: number;
}

export interface NameMasked {
  displayName?: string;
  preferredName?: string;
  prefix?: string;
  suffix?: string;
  tlMaskInfo_firstName: string;
  tlMaskInfo_lastName: string;
  tlMaskInfo_middleName?: string;
}
